// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/services/web/admin.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { CompanyDetails, User } from "../../types/company";
import { GlobalConfig } from "../../types/config";
import { UsageTier } from "../../types/usage";

export const protobufPackage = "api.devplan.services.web.admin";

export enum AdminOnboardingStatus {
  ADMIN_ONBOARDING_STATUS_UNSPECIFIED = 0,
  ADMIN_ONBOARDING_STATUS_ACTIVE = 1,
  ADMIN_ONBOARDING_STATUS_STALLED = 2,
  ADMIN_ONBOARDING_STATUS_FAILED = 3,
  ADMIN_ONBOARDING_STATUS_COMPLETED = 4,
}

export function adminOnboardingStatusFromJSON(object: any): AdminOnboardingStatus {
  switch (object) {
    case 0:
    case "ADMIN_ONBOARDING_STATUS_UNSPECIFIED":
      return AdminOnboardingStatus.ADMIN_ONBOARDING_STATUS_UNSPECIFIED;
    case 1:
    case "ADMIN_ONBOARDING_STATUS_ACTIVE":
      return AdminOnboardingStatus.ADMIN_ONBOARDING_STATUS_ACTIVE;
    case 2:
    case "ADMIN_ONBOARDING_STATUS_STALLED":
      return AdminOnboardingStatus.ADMIN_ONBOARDING_STATUS_STALLED;
    case 3:
    case "ADMIN_ONBOARDING_STATUS_FAILED":
      return AdminOnboardingStatus.ADMIN_ONBOARDING_STATUS_FAILED;
    case 4:
    case "ADMIN_ONBOARDING_STATUS_COMPLETED":
      return AdminOnboardingStatus.ADMIN_ONBOARDING_STATUS_COMPLETED;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AdminOnboardingStatus");
  }
}

export function adminOnboardingStatusToJSON(object: AdminOnboardingStatus): string {
  switch (object) {
    case AdminOnboardingStatus.ADMIN_ONBOARDING_STATUS_UNSPECIFIED:
      return "ADMIN_ONBOARDING_STATUS_UNSPECIFIED";
    case AdminOnboardingStatus.ADMIN_ONBOARDING_STATUS_ACTIVE:
      return "ADMIN_ONBOARDING_STATUS_ACTIVE";
    case AdminOnboardingStatus.ADMIN_ONBOARDING_STATUS_STALLED:
      return "ADMIN_ONBOARDING_STATUS_STALLED";
    case AdminOnboardingStatus.ADMIN_ONBOARDING_STATUS_FAILED:
      return "ADMIN_ONBOARDING_STATUS_FAILED";
    case AdminOnboardingStatus.ADMIN_ONBOARDING_STATUS_COMPLETED:
      return "ADMIN_ONBOARDING_STATUS_COMPLETED";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AdminOnboardingStatus");
  }
}

export interface GetTiersResponse {
  tiers: UsageTier[];
}

export interface UpsertTierRequest {
  tier: UsageTier | undefined;
}

export interface UpsertTierResponse {
  tier: UsageTier | undefined;
}

export interface DeleteTierResponse {
  tiers: UsageTier[];
}

export interface GetGlobalConfigResponse {
  config: GlobalConfig | undefined;
}

export interface UpdateGlobalConfigRequest {
  config: GlobalConfig | undefined;
}

export interface UpdateGlobalConfigResponse {
  config: GlobalConfig | undefined;
}

export interface AdminUserWithRoles {
  user: User | undefined;
  globalRoles: AdminGlobalRole[];
  companyRoles: AdminCompanyRole[];
}

export interface AdminGlobalRole {
  userId: string;
  role: string;
}

export interface AdminCompanyRole {
  userId: string;
  companyId: number;
  role: string;
}

export interface ListAllUsersResponse {
  users: AdminUserWithRoles[];
}

export interface ListAllRolesResponse {
  globalRoles: RoleEntry[];
  companyRoles: RoleEntry[];
}

export interface RoleEntry {
  name: string;
}

export interface ListAllCompaniesResponse {
  companies: CompanyDetails[];
}

export interface ProvisionEnterpriseOrganizationRequest {
  organizationName: string;
  websiteUrl: string;
  ownerEmails: string[];
}

export interface ProvisionEnterpriseOrganizationResponse {
  organizationId: string;
  companyId: number;
  owners: User[];
  subscriptionStatus: string;
  subscriptionId?: string | undefined;
  subscriptionError?: string | undefined;
}

export interface AdminOrganizationListItem {
  organizationId: string;
  organizationName: string;
  companyIds: number[];
  subscriptionStatus: string;
  subscriptionId?: string | undefined;
  createdAt: Date | undefined;
}

export interface ListAdminOrganizationsResponse {
  organizations: AdminOrganizationListItem[];
}

export interface AdminOnboardingIntegration {
  provider: string;
  firstConnectedAt: Date | undefined;
  currentlyConnected: boolean;
  disconnectedAt?: Date | undefined;
}

export interface AdminOnboardingSignup {
  companyId: number;
  organizationId: string;
  workspaceName: string;
  website?: string | undefined;
  actorEmail: string;
  actorEmailDomain: string;
  createdAt: Date | undefined;
  status: AdminOnboardingStatus;
  integrations: AdminOnboardingIntegration[];
  completedAt?: Date | undefined;
  failedAt?: Date | undefined;
  stalledAt?: Date | undefined;
  slackThreadTs?: string | undefined;
  slackLastError?: string | undefined;
}

export interface AdminOnboardingSummary {
  signups7d: number;
  signups30d: number;
  stalled: number;
  failed: number;
  integrationRate30d: number;
  completionRate30d: number;
  medianFirstIntegrationSeconds?: number | undefined;
  medianCompletionSeconds?: number | undefined;
}

export interface ListAdminOnboardingResponse {
  summary: AdminOnboardingSummary | undefined;
  signups: AdminOnboardingSignup[];
  nextCursor?: string | undefined;
}

export interface CreateUserRequest {
  email: string;
}

export interface CreateUserResponse {
  user: User | undefined;
}

export interface SetUserGlobalRoleRequest {
  role: string;
}

export interface SetUserCompanyRoleRequest {
  companyId: number;
  role: string;
}

export interface ListRecentHomeReportsRequest {
  days: number;
  limit: number;
}

export interface ListRecentHomeReportsResponse {
  reportsJson: string[];
  workspaceNamesById: { [key: string]: string };
}

export interface ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry {
  key: string;
  value: string;
}

export interface EnqueueHomeReportDeliveryRequest {
  homeReportId: string;
}

export interface EnqueueHomeReportDeliveryResponse {
  pendingDeliveryId: string;
  reportJson: string;
  message: string;
}

export interface ListAdminLlmUsageRequest {
  startAt: Date | undefined;
  endAt: Date | undefined;
  limit: number;
}

export interface ListAdminLlmUsageResponse {
  entriesJson: string[];
  workspaceNamesById: { [key: string]: string };
}

export interface ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry {
  key: string;
  value: string;
}

function createBaseGetTiersResponse(): GetTiersResponse {
  return { tiers: [] };
}

export const GetTiersResponse: MessageFns<GetTiersResponse> = {
  encode(message: GetTiersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tiers) {
      UsageTier.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTiersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTiersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tiers.push(UsageTier.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTiersResponse {
    return {
      tiers: globalThis.Array.isArray(object?.tiers) ? object.tiers.map((e: any) => UsageTier.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetTiersResponse): unknown {
    const obj: any = {};
    if (message.tiers?.length) {
      obj.tiers = message.tiers.map((e) => UsageTier.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetTiersResponse>): GetTiersResponse {
    return GetTiersResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetTiersResponse>): GetTiersResponse {
    const message = createBaseGetTiersResponse();
    message.tiers = object.tiers?.map((e) => UsageTier.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpsertTierRequest(): UpsertTierRequest {
  return { tier: undefined };
}

export const UpsertTierRequest: MessageFns<UpsertTierRequest> = {
  encode(message: UpsertTierRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tier !== undefined) {
      UsageTier.encode(message.tier, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpsertTierRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertTierRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tier = UsageTier.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertTierRequest {
    return { tier: isSet(object.tier) ? UsageTier.fromJSON(object.tier) : undefined };
  },

  toJSON(message: UpsertTierRequest): unknown {
    const obj: any = {};
    if (message.tier !== undefined) {
      obj.tier = UsageTier.toJSON(message.tier);
    }
    return obj;
  },

  create(base?: DeepPartial<UpsertTierRequest>): UpsertTierRequest {
    return UpsertTierRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpsertTierRequest>): UpsertTierRequest {
    const message = createBaseUpsertTierRequest();
    message.tier = (object.tier !== undefined && object.tier !== null) ? UsageTier.fromPartial(object.tier) : undefined;
    return message;
  },
};

function createBaseUpsertTierResponse(): UpsertTierResponse {
  return { tier: undefined };
}

export const UpsertTierResponse: MessageFns<UpsertTierResponse> = {
  encode(message: UpsertTierResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tier !== undefined) {
      UsageTier.encode(message.tier, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpsertTierResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertTierResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tier = UsageTier.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertTierResponse {
    return { tier: isSet(object.tier) ? UsageTier.fromJSON(object.tier) : undefined };
  },

  toJSON(message: UpsertTierResponse): unknown {
    const obj: any = {};
    if (message.tier !== undefined) {
      obj.tier = UsageTier.toJSON(message.tier);
    }
    return obj;
  },

  create(base?: DeepPartial<UpsertTierResponse>): UpsertTierResponse {
    return UpsertTierResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpsertTierResponse>): UpsertTierResponse {
    const message = createBaseUpsertTierResponse();
    message.tier = (object.tier !== undefined && object.tier !== null) ? UsageTier.fromPartial(object.tier) : undefined;
    return message;
  },
};

function createBaseDeleteTierResponse(): DeleteTierResponse {
  return { tiers: [] };
}

export const DeleteTierResponse: MessageFns<DeleteTierResponse> = {
  encode(message: DeleteTierResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tiers) {
      UsageTier.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteTierResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteTierResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tiers.push(UsageTier.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteTierResponse {
    return {
      tiers: globalThis.Array.isArray(object?.tiers) ? object.tiers.map((e: any) => UsageTier.fromJSON(e)) : [],
    };
  },

  toJSON(message: DeleteTierResponse): unknown {
    const obj: any = {};
    if (message.tiers?.length) {
      obj.tiers = message.tiers.map((e) => UsageTier.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteTierResponse>): DeleteTierResponse {
    return DeleteTierResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteTierResponse>): DeleteTierResponse {
    const message = createBaseDeleteTierResponse();
    message.tiers = object.tiers?.map((e) => UsageTier.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetGlobalConfigResponse(): GetGlobalConfigResponse {
  return { config: undefined };
}

export const GetGlobalConfigResponse: MessageFns<GetGlobalConfigResponse> = {
  encode(message: GetGlobalConfigResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      GlobalConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetGlobalConfigResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetGlobalConfigResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = GlobalConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetGlobalConfigResponse {
    return { config: isSet(object.config) ? GlobalConfig.fromJSON(object.config) : undefined };
  },

  toJSON(message: GetGlobalConfigResponse): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = GlobalConfig.toJSON(message.config);
    }
    return obj;
  },

  create(base?: DeepPartial<GetGlobalConfigResponse>): GetGlobalConfigResponse {
    return GetGlobalConfigResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetGlobalConfigResponse>): GetGlobalConfigResponse {
    const message = createBaseGetGlobalConfigResponse();
    message.config = (object.config !== undefined && object.config !== null)
      ? GlobalConfig.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseUpdateGlobalConfigRequest(): UpdateGlobalConfigRequest {
  return { config: undefined };
}

export const UpdateGlobalConfigRequest: MessageFns<UpdateGlobalConfigRequest> = {
  encode(message: UpdateGlobalConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      GlobalConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateGlobalConfigRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateGlobalConfigRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = GlobalConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateGlobalConfigRequest {
    return { config: isSet(object.config) ? GlobalConfig.fromJSON(object.config) : undefined };
  },

  toJSON(message: UpdateGlobalConfigRequest): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = GlobalConfig.toJSON(message.config);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateGlobalConfigRequest>): UpdateGlobalConfigRequest {
    return UpdateGlobalConfigRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateGlobalConfigRequest>): UpdateGlobalConfigRequest {
    const message = createBaseUpdateGlobalConfigRequest();
    message.config = (object.config !== undefined && object.config !== null)
      ? GlobalConfig.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseUpdateGlobalConfigResponse(): UpdateGlobalConfigResponse {
  return { config: undefined };
}

export const UpdateGlobalConfigResponse: MessageFns<UpdateGlobalConfigResponse> = {
  encode(message: UpdateGlobalConfigResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      GlobalConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateGlobalConfigResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateGlobalConfigResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = GlobalConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateGlobalConfigResponse {
    return { config: isSet(object.config) ? GlobalConfig.fromJSON(object.config) : undefined };
  },

  toJSON(message: UpdateGlobalConfigResponse): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = GlobalConfig.toJSON(message.config);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateGlobalConfigResponse>): UpdateGlobalConfigResponse {
    return UpdateGlobalConfigResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateGlobalConfigResponse>): UpdateGlobalConfigResponse {
    const message = createBaseUpdateGlobalConfigResponse();
    message.config = (object.config !== undefined && object.config !== null)
      ? GlobalConfig.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseAdminUserWithRoles(): AdminUserWithRoles {
  return { user: undefined, globalRoles: [], companyRoles: [] };
}

export const AdminUserWithRoles: MessageFns<AdminUserWithRoles> = {
  encode(message: AdminUserWithRoles, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(10).fork()).join();
    }
    for (const v of message.globalRoles) {
      AdminGlobalRole.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.companyRoles) {
      AdminCompanyRole.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminUserWithRoles {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminUserWithRoles();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.globalRoles.push(AdminGlobalRole.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.companyRoles.push(AdminCompanyRole.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminUserWithRoles {
    return {
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      globalRoles: globalThis.Array.isArray(object?.globalRoles)
        ? object.globalRoles.map((e: any) => AdminGlobalRole.fromJSON(e))
        : globalThis.Array.isArray(object?.global_roles)
        ? object.global_roles.map((e: any) => AdminGlobalRole.fromJSON(e))
        : [],
      companyRoles: globalThis.Array.isArray(object?.companyRoles)
        ? object.companyRoles.map((e: any) => AdminCompanyRole.fromJSON(e))
        : globalThis.Array.isArray(object?.company_roles)
        ? object.company_roles.map((e: any) => AdminCompanyRole.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AdminUserWithRoles): unknown {
    const obj: any = {};
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    if (message.globalRoles?.length) {
      obj.globalRoles = message.globalRoles.map((e) => AdminGlobalRole.toJSON(e));
    }
    if (message.companyRoles?.length) {
      obj.companyRoles = message.companyRoles.map((e) => AdminCompanyRole.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<AdminUserWithRoles>): AdminUserWithRoles {
    return AdminUserWithRoles.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AdminUserWithRoles>): AdminUserWithRoles {
    const message = createBaseAdminUserWithRoles();
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    message.globalRoles = object.globalRoles?.map((e) => AdminGlobalRole.fromPartial(e)) || [];
    message.companyRoles = object.companyRoles?.map((e) => AdminCompanyRole.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAdminGlobalRole(): AdminGlobalRole {
  return { userId: "", role: "" };
}

export const AdminGlobalRole: MessageFns<AdminGlobalRole> = {
  encode(message: AdminGlobalRole, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.role !== "") {
      writer.uint32(18).string(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGlobalRole {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGlobalRole();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.role = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGlobalRole {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      role: isSet(object.role) ? globalThis.String(object.role) : "",
    };
  },

  toJSON(message: AdminGlobalRole): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.role !== "") {
      obj.role = message.role;
    }
    return obj;
  },

  create(base?: DeepPartial<AdminGlobalRole>): AdminGlobalRole {
    return AdminGlobalRole.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AdminGlobalRole>): AdminGlobalRole {
    const message = createBaseAdminGlobalRole();
    message.userId = object.userId ?? "";
    message.role = object.role ?? "";
    return message;
  },
};

function createBaseAdminCompanyRole(): AdminCompanyRole {
  return { userId: "", companyId: 0, role: "" };
}

export const AdminCompanyRole: MessageFns<AdminCompanyRole> = {
  encode(message: AdminCompanyRole, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.role !== "") {
      writer.uint32(26).string(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminCompanyRole {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminCompanyRole();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.role = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminCompanyRole {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      role: isSet(object.role) ? globalThis.String(object.role) : "",
    };
  },

  toJSON(message: AdminCompanyRole): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.role !== "") {
      obj.role = message.role;
    }
    return obj;
  },

  create(base?: DeepPartial<AdminCompanyRole>): AdminCompanyRole {
    return AdminCompanyRole.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AdminCompanyRole>): AdminCompanyRole {
    const message = createBaseAdminCompanyRole();
    message.userId = object.userId ?? "";
    message.companyId = object.companyId ?? 0;
    message.role = object.role ?? "";
    return message;
  },
};

function createBaseListAllUsersResponse(): ListAllUsersResponse {
  return { users: [] };
}

export const ListAllUsersResponse: MessageFns<ListAllUsersResponse> = {
  encode(message: ListAllUsersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.users) {
      AdminUserWithRoles.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListAllUsersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListAllUsersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.users.push(AdminUserWithRoles.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListAllUsersResponse {
    return {
      users: globalThis.Array.isArray(object?.users)
        ? object.users.map((e: any) => AdminUserWithRoles.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListAllUsersResponse): unknown {
    const obj: any = {};
    if (message.users?.length) {
      obj.users = message.users.map((e) => AdminUserWithRoles.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListAllUsersResponse>): ListAllUsersResponse {
    return ListAllUsersResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListAllUsersResponse>): ListAllUsersResponse {
    const message = createBaseListAllUsersResponse();
    message.users = object.users?.map((e) => AdminUserWithRoles.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListAllRolesResponse(): ListAllRolesResponse {
  return { globalRoles: [], companyRoles: [] };
}

export const ListAllRolesResponse: MessageFns<ListAllRolesResponse> = {
  encode(message: ListAllRolesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.globalRoles) {
      RoleEntry.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.companyRoles) {
      RoleEntry.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListAllRolesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListAllRolesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.globalRoles.push(RoleEntry.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.companyRoles.push(RoleEntry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListAllRolesResponse {
    return {
      globalRoles: globalThis.Array.isArray(object?.globalRoles)
        ? object.globalRoles.map((e: any) => RoleEntry.fromJSON(e))
        : globalThis.Array.isArray(object?.global_roles)
        ? object.global_roles.map((e: any) => RoleEntry.fromJSON(e))
        : [],
      companyRoles: globalThis.Array.isArray(object?.companyRoles)
        ? object.companyRoles.map((e: any) => RoleEntry.fromJSON(e))
        : globalThis.Array.isArray(object?.company_roles)
        ? object.company_roles.map((e: any) => RoleEntry.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListAllRolesResponse): unknown {
    const obj: any = {};
    if (message.globalRoles?.length) {
      obj.globalRoles = message.globalRoles.map((e) => RoleEntry.toJSON(e));
    }
    if (message.companyRoles?.length) {
      obj.companyRoles = message.companyRoles.map((e) => RoleEntry.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListAllRolesResponse>): ListAllRolesResponse {
    return ListAllRolesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListAllRolesResponse>): ListAllRolesResponse {
    const message = createBaseListAllRolesResponse();
    message.globalRoles = object.globalRoles?.map((e) => RoleEntry.fromPartial(e)) || [];
    message.companyRoles = object.companyRoles?.map((e) => RoleEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRoleEntry(): RoleEntry {
  return { name: "" };
}

export const RoleEntry: MessageFns<RoleEntry> = {
  encode(message: RoleEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RoleEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoleEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RoleEntry {
    return { name: isSet(object.name) ? globalThis.String(object.name) : "" };
  },

  toJSON(message: RoleEntry): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create(base?: DeepPartial<RoleEntry>): RoleEntry {
    return RoleEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RoleEntry>): RoleEntry {
    const message = createBaseRoleEntry();
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseListAllCompaniesResponse(): ListAllCompaniesResponse {
  return { companies: [] };
}

export const ListAllCompaniesResponse: MessageFns<ListAllCompaniesResponse> = {
  encode(message: ListAllCompaniesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.companies) {
      CompanyDetails.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListAllCompaniesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListAllCompaniesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.companies.push(CompanyDetails.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListAllCompaniesResponse {
    return {
      companies: globalThis.Array.isArray(object?.companies)
        ? object.companies.map((e: any) => CompanyDetails.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListAllCompaniesResponse): unknown {
    const obj: any = {};
    if (message.companies?.length) {
      obj.companies = message.companies.map((e) => CompanyDetails.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListAllCompaniesResponse>): ListAllCompaniesResponse {
    return ListAllCompaniesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListAllCompaniesResponse>): ListAllCompaniesResponse {
    const message = createBaseListAllCompaniesResponse();
    message.companies = object.companies?.map((e) => CompanyDetails.fromPartial(e)) || [];
    return message;
  },
};

function createBaseProvisionEnterpriseOrganizationRequest(): ProvisionEnterpriseOrganizationRequest {
  return { organizationName: "", websiteUrl: "", ownerEmails: [] };
}

export const ProvisionEnterpriseOrganizationRequest: MessageFns<ProvisionEnterpriseOrganizationRequest> = {
  encode(message: ProvisionEnterpriseOrganizationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.organizationName !== "") {
      writer.uint32(10).string(message.organizationName);
    }
    if (message.websiteUrl !== "") {
      writer.uint32(18).string(message.websiteUrl);
    }
    for (const v of message.ownerEmails) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProvisionEnterpriseOrganizationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvisionEnterpriseOrganizationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.organizationName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.websiteUrl = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ownerEmails.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProvisionEnterpriseOrganizationRequest {
    return {
      organizationName: isSet(object.organizationName)
        ? globalThis.String(object.organizationName)
        : isSet(object.organization_name)
        ? globalThis.String(object.organization_name)
        : "",
      websiteUrl: isSet(object.websiteUrl)
        ? globalThis.String(object.websiteUrl)
        : isSet(object.website_url)
        ? globalThis.String(object.website_url)
        : "",
      ownerEmails: globalThis.Array.isArray(object?.ownerEmails)
        ? object.ownerEmails.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.owner_emails)
        ? object.owner_emails.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ProvisionEnterpriseOrganizationRequest): unknown {
    const obj: any = {};
    if (message.organizationName !== "") {
      obj.organizationName = message.organizationName;
    }
    if (message.websiteUrl !== "") {
      obj.websiteUrl = message.websiteUrl;
    }
    if (message.ownerEmails?.length) {
      obj.ownerEmails = message.ownerEmails;
    }
    return obj;
  },

  create(base?: DeepPartial<ProvisionEnterpriseOrganizationRequest>): ProvisionEnterpriseOrganizationRequest {
    return ProvisionEnterpriseOrganizationRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProvisionEnterpriseOrganizationRequest>): ProvisionEnterpriseOrganizationRequest {
    const message = createBaseProvisionEnterpriseOrganizationRequest();
    message.organizationName = object.organizationName ?? "";
    message.websiteUrl = object.websiteUrl ?? "";
    message.ownerEmails = object.ownerEmails?.map((e) => e) || [];
    return message;
  },
};

function createBaseProvisionEnterpriseOrganizationResponse(): ProvisionEnterpriseOrganizationResponse {
  return {
    organizationId: "",
    companyId: 0,
    owners: [],
    subscriptionStatus: "",
    subscriptionId: undefined,
    subscriptionError: undefined,
  };
}

export const ProvisionEnterpriseOrganizationResponse: MessageFns<ProvisionEnterpriseOrganizationResponse> = {
  encode(message: ProvisionEnterpriseOrganizationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.organizationId !== "") {
      writer.uint32(10).string(message.organizationId);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    for (const v of message.owners) {
      User.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.subscriptionStatus !== "") {
      writer.uint32(34).string(message.subscriptionStatus);
    }
    if (message.subscriptionId !== undefined) {
      writer.uint32(42).string(message.subscriptionId);
    }
    if (message.subscriptionError !== undefined) {
      writer.uint32(50).string(message.subscriptionError);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProvisionEnterpriseOrganizationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvisionEnterpriseOrganizationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.owners.push(User.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subscriptionStatus = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.subscriptionId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.subscriptionError = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProvisionEnterpriseOrganizationResponse {
    return {
      organizationId: isSet(object.organizationId)
        ? globalThis.String(object.organizationId)
        : isSet(object.organization_id)
        ? globalThis.String(object.organization_id)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      owners: globalThis.Array.isArray(object?.owners) ? object.owners.map((e: any) => User.fromJSON(e)) : [],
      subscriptionStatus: isSet(object.subscriptionStatus)
        ? globalThis.String(object.subscriptionStatus)
        : isSet(object.subscription_status)
        ? globalThis.String(object.subscription_status)
        : "",
      subscriptionId: isSet(object.subscriptionId)
        ? globalThis.String(object.subscriptionId)
        : isSet(object.subscription_id)
        ? globalThis.String(object.subscription_id)
        : undefined,
      subscriptionError: isSet(object.subscriptionError)
        ? globalThis.String(object.subscriptionError)
        : isSet(object.subscription_error)
        ? globalThis.String(object.subscription_error)
        : undefined,
    };
  },

  toJSON(message: ProvisionEnterpriseOrganizationResponse): unknown {
    const obj: any = {};
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.owners?.length) {
      obj.owners = message.owners.map((e) => User.toJSON(e));
    }
    if (message.subscriptionStatus !== "") {
      obj.subscriptionStatus = message.subscriptionStatus;
    }
    if (message.subscriptionId !== undefined) {
      obj.subscriptionId = message.subscriptionId;
    }
    if (message.subscriptionError !== undefined) {
      obj.subscriptionError = message.subscriptionError;
    }
    return obj;
  },

  create(base?: DeepPartial<ProvisionEnterpriseOrganizationResponse>): ProvisionEnterpriseOrganizationResponse {
    return ProvisionEnterpriseOrganizationResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProvisionEnterpriseOrganizationResponse>): ProvisionEnterpriseOrganizationResponse {
    const message = createBaseProvisionEnterpriseOrganizationResponse();
    message.organizationId = object.organizationId ?? "";
    message.companyId = object.companyId ?? 0;
    message.owners = object.owners?.map((e) => User.fromPartial(e)) || [];
    message.subscriptionStatus = object.subscriptionStatus ?? "";
    message.subscriptionId = object.subscriptionId ?? undefined;
    message.subscriptionError = object.subscriptionError ?? undefined;
    return message;
  },
};

function createBaseAdminOrganizationListItem(): AdminOrganizationListItem {
  return {
    organizationId: "",
    organizationName: "",
    companyIds: [],
    subscriptionStatus: "",
    subscriptionId: undefined,
    createdAt: undefined,
  };
}

export const AdminOrganizationListItem: MessageFns<AdminOrganizationListItem> = {
  encode(message: AdminOrganizationListItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.organizationId !== "") {
      writer.uint32(10).string(message.organizationId);
    }
    if (message.organizationName !== "") {
      writer.uint32(18).string(message.organizationName);
    }
    writer.uint32(26).fork();
    for (const v of message.companyIds) {
      writer.int32(v);
    }
    writer.join();
    if (message.subscriptionStatus !== "") {
      writer.uint32(34).string(message.subscriptionStatus);
    }
    if (message.subscriptionId !== undefined) {
      writer.uint32(42).string(message.subscriptionId);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminOrganizationListItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminOrganizationListItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.organizationName = reader.string();
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.companyIds.push(reader.int32());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.companyIds.push(reader.int32());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subscriptionStatus = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.subscriptionId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminOrganizationListItem {
    return {
      organizationId: isSet(object.organizationId)
        ? globalThis.String(object.organizationId)
        : isSet(object.organization_id)
        ? globalThis.String(object.organization_id)
        : "",
      organizationName: isSet(object.organizationName)
        ? globalThis.String(object.organizationName)
        : isSet(object.organization_name)
        ? globalThis.String(object.organization_name)
        : "",
      companyIds: globalThis.Array.isArray(object?.companyIds)
        ? object.companyIds.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.company_ids)
        ? object.company_ids.map((e: any) => globalThis.Number(e))
        : [],
      subscriptionStatus: isSet(object.subscriptionStatus)
        ? globalThis.String(object.subscriptionStatus)
        : isSet(object.subscription_status)
        ? globalThis.String(object.subscription_status)
        : "",
      subscriptionId: isSet(object.subscriptionId)
        ? globalThis.String(object.subscriptionId)
        : isSet(object.subscription_id)
        ? globalThis.String(object.subscription_id)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
    };
  },

  toJSON(message: AdminOrganizationListItem): unknown {
    const obj: any = {};
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.organizationName !== "") {
      obj.organizationName = message.organizationName;
    }
    if (message.companyIds?.length) {
      obj.companyIds = message.companyIds.map((e) => Math.round(e));
    }
    if (message.subscriptionStatus !== "") {
      obj.subscriptionStatus = message.subscriptionStatus;
    }
    if (message.subscriptionId !== undefined) {
      obj.subscriptionId = message.subscriptionId;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<AdminOrganizationListItem>): AdminOrganizationListItem {
    return AdminOrganizationListItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AdminOrganizationListItem>): AdminOrganizationListItem {
    const message = createBaseAdminOrganizationListItem();
    message.organizationId = object.organizationId ?? "";
    message.organizationName = object.organizationName ?? "";
    message.companyIds = object.companyIds?.map((e) => e) || [];
    message.subscriptionStatus = object.subscriptionStatus ?? "";
    message.subscriptionId = object.subscriptionId ?? undefined;
    message.createdAt = object.createdAt ?? undefined;
    return message;
  },
};

function createBaseListAdminOrganizationsResponse(): ListAdminOrganizationsResponse {
  return { organizations: [] };
}

export const ListAdminOrganizationsResponse: MessageFns<ListAdminOrganizationsResponse> = {
  encode(message: ListAdminOrganizationsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.organizations) {
      AdminOrganizationListItem.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListAdminOrganizationsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListAdminOrganizationsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.organizations.push(AdminOrganizationListItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListAdminOrganizationsResponse {
    return {
      organizations: globalThis.Array.isArray(object?.organizations)
        ? object.organizations.map((e: any) => AdminOrganizationListItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListAdminOrganizationsResponse): unknown {
    const obj: any = {};
    if (message.organizations?.length) {
      obj.organizations = message.organizations.map((e) => AdminOrganizationListItem.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListAdminOrganizationsResponse>): ListAdminOrganizationsResponse {
    return ListAdminOrganizationsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListAdminOrganizationsResponse>): ListAdminOrganizationsResponse {
    const message = createBaseListAdminOrganizationsResponse();
    message.organizations = object.organizations?.map((e) => AdminOrganizationListItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAdminOnboardingIntegration(): AdminOnboardingIntegration {
  return { provider: "", firstConnectedAt: undefined, currentlyConnected: false, disconnectedAt: undefined };
}

export const AdminOnboardingIntegration: MessageFns<AdminOnboardingIntegration> = {
  encode(message: AdminOnboardingIntegration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== "") {
      writer.uint32(10).string(message.provider);
    }
    if (message.firstConnectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.firstConnectedAt), writer.uint32(18).fork()).join();
    }
    if (message.currentlyConnected !== false) {
      writer.uint32(24).bool(message.currentlyConnected);
    }
    if (message.disconnectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.disconnectedAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminOnboardingIntegration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminOnboardingIntegration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.firstConnectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.currentlyConnected = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.disconnectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminOnboardingIntegration {
    return {
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      firstConnectedAt: isSet(object.firstConnectedAt)
        ? fromJsonTimestamp(object.firstConnectedAt)
        : isSet(object.first_connected_at)
        ? fromJsonTimestamp(object.first_connected_at)
        : undefined,
      currentlyConnected: isSet(object.currentlyConnected)
        ? globalThis.Boolean(object.currentlyConnected)
        : isSet(object.currently_connected)
        ? globalThis.Boolean(object.currently_connected)
        : false,
      disconnectedAt: isSet(object.disconnectedAt)
        ? fromJsonTimestamp(object.disconnectedAt)
        : isSet(object.disconnected_at)
        ? fromJsonTimestamp(object.disconnected_at)
        : undefined,
    };
  },

  toJSON(message: AdminOnboardingIntegration): unknown {
    const obj: any = {};
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.firstConnectedAt !== undefined) {
      obj.firstConnectedAt = message.firstConnectedAt.toISOString();
    }
    if (message.currentlyConnected !== false) {
      obj.currentlyConnected = message.currentlyConnected;
    }
    if (message.disconnectedAt !== undefined) {
      obj.disconnectedAt = message.disconnectedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<AdminOnboardingIntegration>): AdminOnboardingIntegration {
    return AdminOnboardingIntegration.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AdminOnboardingIntegration>): AdminOnboardingIntegration {
    const message = createBaseAdminOnboardingIntegration();
    message.provider = object.provider ?? "";
    message.firstConnectedAt = object.firstConnectedAt ?? undefined;
    message.currentlyConnected = object.currentlyConnected ?? false;
    message.disconnectedAt = object.disconnectedAt ?? undefined;
    return message;
  },
};

function createBaseAdminOnboardingSignup(): AdminOnboardingSignup {
  return {
    companyId: 0,
    organizationId: "",
    workspaceName: "",
    website: undefined,
    actorEmail: "",
    actorEmailDomain: "",
    createdAt: undefined,
    status: 0,
    integrations: [],
    completedAt: undefined,
    failedAt: undefined,
    stalledAt: undefined,
    slackThreadTs: undefined,
    slackLastError: undefined,
  };
}

export const AdminOnboardingSignup: MessageFns<AdminOnboardingSignup> = {
  encode(message: AdminOnboardingSignup, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.organizationId !== "") {
      writer.uint32(18).string(message.organizationId);
    }
    if (message.workspaceName !== "") {
      writer.uint32(26).string(message.workspaceName);
    }
    if (message.website !== undefined) {
      writer.uint32(34).string(message.website);
    }
    if (message.actorEmail !== "") {
      writer.uint32(42).string(message.actorEmail);
    }
    if (message.actorEmailDomain !== "") {
      writer.uint32(50).string(message.actorEmailDomain);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(58).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(64).int32(message.status);
    }
    for (const v of message.integrations) {
      AdminOnboardingIntegration.encode(v!, writer.uint32(74).fork()).join();
    }
    if (message.completedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.completedAt), writer.uint32(82).fork()).join();
    }
    if (message.failedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.failedAt), writer.uint32(90).fork()).join();
    }
    if (message.stalledAt !== undefined) {
      Timestamp.encode(toTimestamp(message.stalledAt), writer.uint32(98).fork()).join();
    }
    if (message.slackThreadTs !== undefined) {
      writer.uint32(106).string(message.slackThreadTs);
    }
    if (message.slackLastError !== undefined) {
      writer.uint32(114).string(message.slackLastError);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminOnboardingSignup {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminOnboardingSignup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.workspaceName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.website = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.actorEmail = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.actorEmailDomain = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.integrations.push(AdminOnboardingIntegration.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.completedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.failedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.stalledAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.slackThreadTs = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.slackLastError = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminOnboardingSignup {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      organizationId: isSet(object.organizationId)
        ? globalThis.String(object.organizationId)
        : isSet(object.organization_id)
        ? globalThis.String(object.organization_id)
        : "",
      workspaceName: isSet(object.workspaceName)
        ? globalThis.String(object.workspaceName)
        : isSet(object.workspace_name)
        ? globalThis.String(object.workspace_name)
        : "",
      website: isSet(object.website) ? globalThis.String(object.website) : undefined,
      actorEmail: isSet(object.actorEmail)
        ? globalThis.String(object.actorEmail)
        : isSet(object.actor_email)
        ? globalThis.String(object.actor_email)
        : "",
      actorEmailDomain: isSet(object.actorEmailDomain)
        ? globalThis.String(object.actorEmailDomain)
        : isSet(object.actor_email_domain)
        ? globalThis.String(object.actor_email_domain)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      status: isSet(object.status) ? adminOnboardingStatusFromJSON(object.status) : 0,
      integrations: globalThis.Array.isArray(object?.integrations)
        ? object.integrations.map((e: any) => AdminOnboardingIntegration.fromJSON(e))
        : [],
      completedAt: isSet(object.completedAt)
        ? fromJsonTimestamp(object.completedAt)
        : isSet(object.completed_at)
        ? fromJsonTimestamp(object.completed_at)
        : undefined,
      failedAt: isSet(object.failedAt)
        ? fromJsonTimestamp(object.failedAt)
        : isSet(object.failed_at)
        ? fromJsonTimestamp(object.failed_at)
        : undefined,
      stalledAt: isSet(object.stalledAt)
        ? fromJsonTimestamp(object.stalledAt)
        : isSet(object.stalled_at)
        ? fromJsonTimestamp(object.stalled_at)
        : undefined,
      slackThreadTs: isSet(object.slackThreadTs)
        ? globalThis.String(object.slackThreadTs)
        : isSet(object.slack_thread_ts)
        ? globalThis.String(object.slack_thread_ts)
        : undefined,
      slackLastError: isSet(object.slackLastError)
        ? globalThis.String(object.slackLastError)
        : isSet(object.slack_last_error)
        ? globalThis.String(object.slack_last_error)
        : undefined,
    };
  },

  toJSON(message: AdminOnboardingSignup): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.workspaceName !== "") {
      obj.workspaceName = message.workspaceName;
    }
    if (message.website !== undefined) {
      obj.website = message.website;
    }
    if (message.actorEmail !== "") {
      obj.actorEmail = message.actorEmail;
    }
    if (message.actorEmailDomain !== "") {
      obj.actorEmailDomain = message.actorEmailDomain;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.status !== 0) {
      obj.status = adminOnboardingStatusToJSON(message.status);
    }
    if (message.integrations?.length) {
      obj.integrations = message.integrations.map((e) => AdminOnboardingIntegration.toJSON(e));
    }
    if (message.completedAt !== undefined) {
      obj.completedAt = message.completedAt.toISOString();
    }
    if (message.failedAt !== undefined) {
      obj.failedAt = message.failedAt.toISOString();
    }
    if (message.stalledAt !== undefined) {
      obj.stalledAt = message.stalledAt.toISOString();
    }
    if (message.slackThreadTs !== undefined) {
      obj.slackThreadTs = message.slackThreadTs;
    }
    if (message.slackLastError !== undefined) {
      obj.slackLastError = message.slackLastError;
    }
    return obj;
  },

  create(base?: DeepPartial<AdminOnboardingSignup>): AdminOnboardingSignup {
    return AdminOnboardingSignup.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AdminOnboardingSignup>): AdminOnboardingSignup {
    const message = createBaseAdminOnboardingSignup();
    message.companyId = object.companyId ?? 0;
    message.organizationId = object.organizationId ?? "";
    message.workspaceName = object.workspaceName ?? "";
    message.website = object.website ?? undefined;
    message.actorEmail = object.actorEmail ?? "";
    message.actorEmailDomain = object.actorEmailDomain ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.status = object.status ?? 0;
    message.integrations = object.integrations?.map((e) => AdminOnboardingIntegration.fromPartial(e)) || [];
    message.completedAt = object.completedAt ?? undefined;
    message.failedAt = object.failedAt ?? undefined;
    message.stalledAt = object.stalledAt ?? undefined;
    message.slackThreadTs = object.slackThreadTs ?? undefined;
    message.slackLastError = object.slackLastError ?? undefined;
    return message;
  },
};

function createBaseAdminOnboardingSummary(): AdminOnboardingSummary {
  return {
    signups7d: 0,
    signups30d: 0,
    stalled: 0,
    failed: 0,
    integrationRate30d: 0,
    completionRate30d: 0,
    medianFirstIntegrationSeconds: undefined,
    medianCompletionSeconds: undefined,
  };
}

export const AdminOnboardingSummary: MessageFns<AdminOnboardingSummary> = {
  encode(message: AdminOnboardingSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.signups7d !== 0) {
      writer.uint32(8).int32(message.signups7d);
    }
    if (message.signups30d !== 0) {
      writer.uint32(16).int32(message.signups30d);
    }
    if (message.stalled !== 0) {
      writer.uint32(24).int32(message.stalled);
    }
    if (message.failed !== 0) {
      writer.uint32(32).int32(message.failed);
    }
    if (message.integrationRate30d !== 0) {
      writer.uint32(41).double(message.integrationRate30d);
    }
    if (message.completionRate30d !== 0) {
      writer.uint32(49).double(message.completionRate30d);
    }
    if (message.medianFirstIntegrationSeconds !== undefined) {
      writer.uint32(56).int64(message.medianFirstIntegrationSeconds);
    }
    if (message.medianCompletionSeconds !== undefined) {
      writer.uint32(64).int64(message.medianCompletionSeconds);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminOnboardingSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminOnboardingSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.signups7d = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.signups30d = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.stalled = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.failed = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.integrationRate30d = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.completionRate30d = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.medianFirstIntegrationSeconds = longToNumber(reader.int64());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.medianCompletionSeconds = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminOnboardingSummary {
    return {
      signups7d: isSet(object.signups7d)
        ? globalThis.Number(object.signups7d)
        : isSet(object.signups_7d)
        ? globalThis.Number(object.signups_7d)
        : 0,
      signups30d: isSet(object.signups30d)
        ? globalThis.Number(object.signups30d)
        : isSet(object.signups_30d)
        ? globalThis.Number(object.signups_30d)
        : 0,
      stalled: isSet(object.stalled) ? globalThis.Number(object.stalled) : 0,
      failed: isSet(object.failed) ? globalThis.Number(object.failed) : 0,
      integrationRate30d: isSet(object.integrationRate30d)
        ? globalThis.Number(object.integrationRate30d)
        : isSet(object.integration_rate_30d)
        ? globalThis.Number(object.integration_rate_30d)
        : 0,
      completionRate30d: isSet(object.completionRate30d)
        ? globalThis.Number(object.completionRate30d)
        : isSet(object.completion_rate_30d)
        ? globalThis.Number(object.completion_rate_30d)
        : 0,
      medianFirstIntegrationSeconds: isSet(object.medianFirstIntegrationSeconds)
        ? globalThis.Number(object.medianFirstIntegrationSeconds)
        : isSet(object.median_first_integration_seconds)
        ? globalThis.Number(object.median_first_integration_seconds)
        : undefined,
      medianCompletionSeconds: isSet(object.medianCompletionSeconds)
        ? globalThis.Number(object.medianCompletionSeconds)
        : isSet(object.median_completion_seconds)
        ? globalThis.Number(object.median_completion_seconds)
        : undefined,
    };
  },

  toJSON(message: AdminOnboardingSummary): unknown {
    const obj: any = {};
    if (message.signups7d !== 0) {
      obj.signups7d = Math.round(message.signups7d);
    }
    if (message.signups30d !== 0) {
      obj.signups30d = Math.round(message.signups30d);
    }
    if (message.stalled !== 0) {
      obj.stalled = Math.round(message.stalled);
    }
    if (message.failed !== 0) {
      obj.failed = Math.round(message.failed);
    }
    if (message.integrationRate30d !== 0) {
      obj.integrationRate30d = message.integrationRate30d;
    }
    if (message.completionRate30d !== 0) {
      obj.completionRate30d = message.completionRate30d;
    }
    if (message.medianFirstIntegrationSeconds !== undefined) {
      obj.medianFirstIntegrationSeconds = Math.round(message.medianFirstIntegrationSeconds);
    }
    if (message.medianCompletionSeconds !== undefined) {
      obj.medianCompletionSeconds = Math.round(message.medianCompletionSeconds);
    }
    return obj;
  },

  create(base?: DeepPartial<AdminOnboardingSummary>): AdminOnboardingSummary {
    return AdminOnboardingSummary.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AdminOnboardingSummary>): AdminOnboardingSummary {
    const message = createBaseAdminOnboardingSummary();
    message.signups7d = object.signups7d ?? 0;
    message.signups30d = object.signups30d ?? 0;
    message.stalled = object.stalled ?? 0;
    message.failed = object.failed ?? 0;
    message.integrationRate30d = object.integrationRate30d ?? 0;
    message.completionRate30d = object.completionRate30d ?? 0;
    message.medianFirstIntegrationSeconds = object.medianFirstIntegrationSeconds ?? undefined;
    message.medianCompletionSeconds = object.medianCompletionSeconds ?? undefined;
    return message;
  },
};

function createBaseListAdminOnboardingResponse(): ListAdminOnboardingResponse {
  return { summary: undefined, signups: [], nextCursor: undefined };
}

export const ListAdminOnboardingResponse: MessageFns<ListAdminOnboardingResponse> = {
  encode(message: ListAdminOnboardingResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.summary !== undefined) {
      AdminOnboardingSummary.encode(message.summary, writer.uint32(10).fork()).join();
    }
    for (const v of message.signups) {
      AdminOnboardingSignup.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.nextCursor !== undefined) {
      writer.uint32(26).string(message.nextCursor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListAdminOnboardingResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListAdminOnboardingResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.summary = AdminOnboardingSummary.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.signups.push(AdminOnboardingSignup.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nextCursor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListAdminOnboardingResponse {
    return {
      summary: isSet(object.summary) ? AdminOnboardingSummary.fromJSON(object.summary) : undefined,
      signups: globalThis.Array.isArray(object?.signups)
        ? object.signups.map((e: any) => AdminOnboardingSignup.fromJSON(e))
        : [],
      nextCursor: isSet(object.nextCursor)
        ? globalThis.String(object.nextCursor)
        : isSet(object.next_cursor)
        ? globalThis.String(object.next_cursor)
        : undefined,
    };
  },

  toJSON(message: ListAdminOnboardingResponse): unknown {
    const obj: any = {};
    if (message.summary !== undefined) {
      obj.summary = AdminOnboardingSummary.toJSON(message.summary);
    }
    if (message.signups?.length) {
      obj.signups = message.signups.map((e) => AdminOnboardingSignup.toJSON(e));
    }
    if (message.nextCursor !== undefined) {
      obj.nextCursor = message.nextCursor;
    }
    return obj;
  },

  create(base?: DeepPartial<ListAdminOnboardingResponse>): ListAdminOnboardingResponse {
    return ListAdminOnboardingResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListAdminOnboardingResponse>): ListAdminOnboardingResponse {
    const message = createBaseListAdminOnboardingResponse();
    message.summary = (object.summary !== undefined && object.summary !== null)
      ? AdminOnboardingSummary.fromPartial(object.summary)
      : undefined;
    message.signups = object.signups?.map((e) => AdminOnboardingSignup.fromPartial(e)) || [];
    message.nextCursor = object.nextCursor ?? undefined;
    return message;
  },
};

function createBaseCreateUserRequest(): CreateUserRequest {
  return { email: "" };
}

export const CreateUserRequest: MessageFns<CreateUserRequest> = {
  encode(message: CreateUserRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateUserRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateUserRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateUserRequest {
    return { email: isSet(object.email) ? globalThis.String(object.email) : "" };
  },

  toJSON(message: CreateUserRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateUserRequest>): CreateUserRequest {
    return CreateUserRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateUserRequest>): CreateUserRequest {
    const message = createBaseCreateUserRequest();
    message.email = object.email ?? "";
    return message;
  },
};

function createBaseCreateUserResponse(): CreateUserResponse {
  return { user: undefined };
}

export const CreateUserResponse: MessageFns<CreateUserResponse> = {
  encode(message: CreateUserResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateUserResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateUserResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateUserResponse {
    return { user: isSet(object.user) ? User.fromJSON(object.user) : undefined };
  },

  toJSON(message: CreateUserResponse): unknown {
    const obj: any = {};
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateUserResponse>): CreateUserResponse {
    return CreateUserResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateUserResponse>): CreateUserResponse {
    const message = createBaseCreateUserResponse();
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    return message;
  },
};

function createBaseSetUserGlobalRoleRequest(): SetUserGlobalRoleRequest {
  return { role: "" };
}

export const SetUserGlobalRoleRequest: MessageFns<SetUserGlobalRoleRequest> = {
  encode(message: SetUserGlobalRoleRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.role !== "") {
      writer.uint32(10).string(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetUserGlobalRoleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetUserGlobalRoleRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.role = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetUserGlobalRoleRequest {
    return { role: isSet(object.role) ? globalThis.String(object.role) : "" };
  },

  toJSON(message: SetUserGlobalRoleRequest): unknown {
    const obj: any = {};
    if (message.role !== "") {
      obj.role = message.role;
    }
    return obj;
  },

  create(base?: DeepPartial<SetUserGlobalRoleRequest>): SetUserGlobalRoleRequest {
    return SetUserGlobalRoleRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetUserGlobalRoleRequest>): SetUserGlobalRoleRequest {
    const message = createBaseSetUserGlobalRoleRequest();
    message.role = object.role ?? "";
    return message;
  },
};

function createBaseSetUserCompanyRoleRequest(): SetUserCompanyRoleRequest {
  return { companyId: 0, role: "" };
}

export const SetUserCompanyRoleRequest: MessageFns<SetUserCompanyRoleRequest> = {
  encode(message: SetUserCompanyRoleRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.role !== "") {
      writer.uint32(18).string(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetUserCompanyRoleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetUserCompanyRoleRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.role = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetUserCompanyRoleRequest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      role: isSet(object.role) ? globalThis.String(object.role) : "",
    };
  },

  toJSON(message: SetUserCompanyRoleRequest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.role !== "") {
      obj.role = message.role;
    }
    return obj;
  },

  create(base?: DeepPartial<SetUserCompanyRoleRequest>): SetUserCompanyRoleRequest {
    return SetUserCompanyRoleRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetUserCompanyRoleRequest>): SetUserCompanyRoleRequest {
    const message = createBaseSetUserCompanyRoleRequest();
    message.companyId = object.companyId ?? 0;
    message.role = object.role ?? "";
    return message;
  },
};

function createBaseListRecentHomeReportsRequest(): ListRecentHomeReportsRequest {
  return { days: 0, limit: 0 };
}

export const ListRecentHomeReportsRequest: MessageFns<ListRecentHomeReportsRequest> = {
  encode(message: ListRecentHomeReportsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.days !== 0) {
      writer.uint32(8).int32(message.days);
    }
    if (message.limit !== 0) {
      writer.uint32(16).int32(message.limit);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRecentHomeReportsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRecentHomeReportsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.days = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRecentHomeReportsRequest {
    return {
      days: isSet(object.days) ? globalThis.Number(object.days) : 0,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
    };
  },

  toJSON(message: ListRecentHomeReportsRequest): unknown {
    const obj: any = {};
    if (message.days !== 0) {
      obj.days = Math.round(message.days);
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    return obj;
  },

  create(base?: DeepPartial<ListRecentHomeReportsRequest>): ListRecentHomeReportsRequest {
    return ListRecentHomeReportsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListRecentHomeReportsRequest>): ListRecentHomeReportsRequest {
    const message = createBaseListRecentHomeReportsRequest();
    message.days = object.days ?? 0;
    message.limit = object.limit ?? 0;
    return message;
  },
};

function createBaseListRecentHomeReportsResponse(): ListRecentHomeReportsResponse {
  return { reportsJson: [], workspaceNamesById: {} };
}

export const ListRecentHomeReportsResponse: MessageFns<ListRecentHomeReportsResponse> = {
  encode(message: ListRecentHomeReportsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.reportsJson) {
      writer.uint32(10).string(v!);
    }
    globalThis.Object.entries(message.workspaceNamesById).forEach(([key, value]: [string, string]) => {
      ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry.encode({ key: key as any, value }, writer.uint32(18).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRecentHomeReportsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRecentHomeReportsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reportsJson.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.workspaceNamesById[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRecentHomeReportsResponse {
    return {
      reportsJson: globalThis.Array.isArray(object?.reportsJson)
        ? object.reportsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.reports_json)
        ? object.reports_json.map((e: any) => globalThis.String(e))
        : [],
      workspaceNamesById: isObject(object.workspaceNamesById)
        ? (globalThis.Object.entries(object.workspaceNamesById) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : isObject(object.workspace_names_by_id)
        ? (globalThis.Object.entries(object.workspace_names_by_id) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: ListRecentHomeReportsResponse): unknown {
    const obj: any = {};
    if (message.reportsJson?.length) {
      obj.reportsJson = message.reportsJson;
    }
    if (message.workspaceNamesById) {
      const entries = globalThis.Object.entries(message.workspaceNamesById) as [string, string][];
      if (entries.length > 0) {
        obj.workspaceNamesById = {};
        entries.forEach(([k, v]) => {
          obj.workspaceNamesById[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<ListRecentHomeReportsResponse>): ListRecentHomeReportsResponse {
    return ListRecentHomeReportsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListRecentHomeReportsResponse>): ListRecentHomeReportsResponse {
    const message = createBaseListRecentHomeReportsResponse();
    message.reportsJson = object.reportsJson?.map((e) => e) || [];
    message.workspaceNamesById = (globalThis.Object.entries(object.workspaceNamesById ?? {}) as [string, string][])
      .reduce((acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      }, {});
    return message;
  },
};

function createBaseListRecentHomeReportsResponse_WorkspaceNamesByIdEntry(): ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry {
  return { key: "", value: "" };
}

export const ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry: MessageFns<
  ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry
> = {
  encode(
    message: ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRecentHomeReportsResponse_WorkspaceNamesByIdEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(
    base?: DeepPartial<ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry>,
  ): ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry {
    return ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry>,
  ): ListRecentHomeReportsResponse_WorkspaceNamesByIdEntry {
    const message = createBaseListRecentHomeReportsResponse_WorkspaceNamesByIdEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseEnqueueHomeReportDeliveryRequest(): EnqueueHomeReportDeliveryRequest {
  return { homeReportId: "" };
}

export const EnqueueHomeReportDeliveryRequest: MessageFns<EnqueueHomeReportDeliveryRequest> = {
  encode(message: EnqueueHomeReportDeliveryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.homeReportId !== "") {
      writer.uint32(10).string(message.homeReportId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnqueueHomeReportDeliveryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnqueueHomeReportDeliveryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.homeReportId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnqueueHomeReportDeliveryRequest {
    return {
      homeReportId: isSet(object.homeReportId)
        ? globalThis.String(object.homeReportId)
        : isSet(object.home_report_id)
        ? globalThis.String(object.home_report_id)
        : "",
    };
  },

  toJSON(message: EnqueueHomeReportDeliveryRequest): unknown {
    const obj: any = {};
    if (message.homeReportId !== "") {
      obj.homeReportId = message.homeReportId;
    }
    return obj;
  },

  create(base?: DeepPartial<EnqueueHomeReportDeliveryRequest>): EnqueueHomeReportDeliveryRequest {
    return EnqueueHomeReportDeliveryRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EnqueueHomeReportDeliveryRequest>): EnqueueHomeReportDeliveryRequest {
    const message = createBaseEnqueueHomeReportDeliveryRequest();
    message.homeReportId = object.homeReportId ?? "";
    return message;
  },
};

function createBaseEnqueueHomeReportDeliveryResponse(): EnqueueHomeReportDeliveryResponse {
  return { pendingDeliveryId: "", reportJson: "", message: "" };
}

export const EnqueueHomeReportDeliveryResponse: MessageFns<EnqueueHomeReportDeliveryResponse> = {
  encode(message: EnqueueHomeReportDeliveryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pendingDeliveryId !== "") {
      writer.uint32(10).string(message.pendingDeliveryId);
    }
    if (message.reportJson !== "") {
      writer.uint32(18).string(message.reportJson);
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnqueueHomeReportDeliveryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnqueueHomeReportDeliveryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pendingDeliveryId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reportJson = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnqueueHomeReportDeliveryResponse {
    return {
      pendingDeliveryId: isSet(object.pendingDeliveryId)
        ? globalThis.String(object.pendingDeliveryId)
        : isSet(object.pending_delivery_id)
        ? globalThis.String(object.pending_delivery_id)
        : "",
      reportJson: isSet(object.reportJson)
        ? globalThis.String(object.reportJson)
        : isSet(object.report_json)
        ? globalThis.String(object.report_json)
        : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: EnqueueHomeReportDeliveryResponse): unknown {
    const obj: any = {};
    if (message.pendingDeliveryId !== "") {
      obj.pendingDeliveryId = message.pendingDeliveryId;
    }
    if (message.reportJson !== "") {
      obj.reportJson = message.reportJson;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create(base?: DeepPartial<EnqueueHomeReportDeliveryResponse>): EnqueueHomeReportDeliveryResponse {
    return EnqueueHomeReportDeliveryResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EnqueueHomeReportDeliveryResponse>): EnqueueHomeReportDeliveryResponse {
    const message = createBaseEnqueueHomeReportDeliveryResponse();
    message.pendingDeliveryId = object.pendingDeliveryId ?? "";
    message.reportJson = object.reportJson ?? "";
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseListAdminLlmUsageRequest(): ListAdminLlmUsageRequest {
  return { startAt: undefined, endAt: undefined, limit: 0 };
}

export const ListAdminLlmUsageRequest: MessageFns<ListAdminLlmUsageRequest> = {
  encode(message: ListAdminLlmUsageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startAt !== undefined) {
      Timestamp.encode(toTimestamp(message.startAt), writer.uint32(10).fork()).join();
    }
    if (message.endAt !== undefined) {
      Timestamp.encode(toTimestamp(message.endAt), writer.uint32(18).fork()).join();
    }
    if (message.limit !== 0) {
      writer.uint32(24).int32(message.limit);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListAdminLlmUsageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListAdminLlmUsageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.startAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.endAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.limit = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListAdminLlmUsageRequest {
    return {
      startAt: isSet(object.startAt)
        ? fromJsonTimestamp(object.startAt)
        : isSet(object.start_at)
        ? fromJsonTimestamp(object.start_at)
        : undefined,
      endAt: isSet(object.endAt)
        ? fromJsonTimestamp(object.endAt)
        : isSet(object.end_at)
        ? fromJsonTimestamp(object.end_at)
        : undefined,
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
    };
  },

  toJSON(message: ListAdminLlmUsageRequest): unknown {
    const obj: any = {};
    if (message.startAt !== undefined) {
      obj.startAt = message.startAt.toISOString();
    }
    if (message.endAt !== undefined) {
      obj.endAt = message.endAt.toISOString();
    }
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    return obj;
  },

  create(base?: DeepPartial<ListAdminLlmUsageRequest>): ListAdminLlmUsageRequest {
    return ListAdminLlmUsageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListAdminLlmUsageRequest>): ListAdminLlmUsageRequest {
    const message = createBaseListAdminLlmUsageRequest();
    message.startAt = object.startAt ?? undefined;
    message.endAt = object.endAt ?? undefined;
    message.limit = object.limit ?? 0;
    return message;
  },
};

function createBaseListAdminLlmUsageResponse(): ListAdminLlmUsageResponse {
  return { entriesJson: [], workspaceNamesById: {} };
}

export const ListAdminLlmUsageResponse: MessageFns<ListAdminLlmUsageResponse> = {
  encode(message: ListAdminLlmUsageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entriesJson) {
      writer.uint32(10).string(v!);
    }
    globalThis.Object.entries(message.workspaceNamesById).forEach(([key, value]: [string, string]) => {
      ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry.encode({ key: key as any, value }, writer.uint32(18).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListAdminLlmUsageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListAdminLlmUsageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entriesJson.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.workspaceNamesById[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListAdminLlmUsageResponse {
    return {
      entriesJson: globalThis.Array.isArray(object?.entriesJson)
        ? object.entriesJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.entries_json)
        ? object.entries_json.map((e: any) => globalThis.String(e))
        : [],
      workspaceNamesById: isObject(object.workspaceNamesById)
        ? (globalThis.Object.entries(object.workspaceNamesById) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : isObject(object.workspace_names_by_id)
        ? (globalThis.Object.entries(object.workspace_names_by_id) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: ListAdminLlmUsageResponse): unknown {
    const obj: any = {};
    if (message.entriesJson?.length) {
      obj.entriesJson = message.entriesJson;
    }
    if (message.workspaceNamesById) {
      const entries = globalThis.Object.entries(message.workspaceNamesById) as [string, string][];
      if (entries.length > 0) {
        obj.workspaceNamesById = {};
        entries.forEach(([k, v]) => {
          obj.workspaceNamesById[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<ListAdminLlmUsageResponse>): ListAdminLlmUsageResponse {
    return ListAdminLlmUsageResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListAdminLlmUsageResponse>): ListAdminLlmUsageResponse {
    const message = createBaseListAdminLlmUsageResponse();
    message.entriesJson = object.entriesJson?.map((e) => e) || [];
    message.workspaceNamesById = (globalThis.Object.entries(object.workspaceNamesById ?? {}) as [string, string][])
      .reduce((acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      }, {});
    return message;
  },
};

function createBaseListAdminLlmUsageResponse_WorkspaceNamesByIdEntry(): ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry {
  return { key: "", value: "" };
}

export const ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry: MessageFns<
  ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry
> = {
  encode(
    message: ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListAdminLlmUsageResponse_WorkspaceNamesByIdEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(
    base?: DeepPartial<ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry>,
  ): ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry {
    return ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry>,
  ): ListAdminLlmUsageResponse_WorkspaceNamesByIdEntry {
    const message = createBaseListAdminLlmUsageResponse_WorkspaceNamesByIdEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
